import { RouteObject } from "react-router";

const routes: RouteObject = {
    path: '/blog/tags',
    lazy: {
        Component: async () => (
            (await import('./Index')).default
        ),
    },
};

export default routes;
